(function () {
  var setHeaderHeight = function () {
    var header = document.querySelector(".v2mn-header");
    if (!header) return;
    document.documentElement.style.setProperty("--header-height", header.offsetHeight + "px");
  };
  setHeaderHeight();
  window.addEventListener("resize", setHeaderHeight);

  var drawer = document.querySelector("[data-drawer]");
  var search = document.querySelector("[data-search]");
  var cart = document.querySelector("[data-cart-drawer]");

  document.querySelectorAll("[data-drawer-open]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (drawer) drawer.classList.add("is-open");
    });
  });
  document.querySelectorAll("[data-drawer-close]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (drawer) drawer.classList.remove("is-open");
    });
  });
  document.querySelectorAll("[data-search-open]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (search) search.classList.toggle("is-open");
    });
  });
  document.querySelectorAll("[data-cart-open]").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      if (!cart) return;
      e.preventDefault();
      cart.classList.add("is-open");
    });
  });
  document.querySelectorAll("[data-cart-close]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (cart) cart.classList.remove("is-open");
    });
  });

  var moneyCents = function (cents) {
    return "$" + (Number(cents) / 100).toFixed(2);
  };
  var setCartCount = function (n) {
    var link = document.querySelector(".v2mn-cart");
    var badge = document.querySelector(".v2mn-cart__count");
    if (n > 0) {
      if (!badge && link) {
        badge = document.createElement("span");
        badge.className = "v2mn-cart__count";
        link.appendChild(badge);
      }
      if (badge) badge.textContent = String(n);
    } else if (badge) {
      badge.parentNode.removeChild(badge);
    }
  };
  var cartPage = document.querySelector("[data-cart-page]");
  var applyCartState = function (data) {
    if (!data) return;
    setCartCount(data.item_count || 0);
    document.querySelectorAll("[data-cart-subtotal]").forEach(function (sub) {
      sub.textContent = moneyCents(data.total_price);
    });
    if (!data.item_count) {
      if (cart) {
        var body = cart.querySelector(".hs-cart__body");
        var foot = cart.querySelector(".hs-cart__foot");
        if (body) body.innerHTML = "<p>Your cart is empty.</p>";
        if (foot) foot.style.display = "none";
      }
      if (cartPage) {
        var pageBody = cartPage.querySelector("[data-cart-body]");
        var pageFoot = cartPage.querySelector("[data-cart-foot]");
        if (pageBody) pageBody.innerHTML = '<p>Your cart is empty.</p><p><a href="/products/hairstory-1">Shop New Wash</a></p>';
        if (pageFoot) pageFoot.style.display = "none";
      }
      return;
    }
    var items = data.items || [];
    document.querySelectorAll("[data-cart-item]").forEach(function (row) {
      var key = row.getAttribute("data-key");
      var vid = row.getAttribute("data-variant");
      var item = null;
      for (var i = 0; i < items.length; i++) {
        if (items[i].key === key || String(items[i].variant_id) === String(vid) || String(items[i].id) === String(vid)) {
          item = items[i];
        }
      }
      if (!item) {
        row.parentNode.removeChild(row);
        return;
      }
      row.setAttribute("data-key", item.key);
      var input = row.querySelector("[data-cart-qty-input]");
      var line = row.querySelector("[data-cart-line]");
      if (input) input.value = item.quantity;
      if (line) line.textContent = moneyCents(item.final_line_price);
    });
  };
  var changeCartItem = function (key, qty) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(applyCartState);
  };
  var bindCartQty = function (root) {
    if (!root) return;
    root.addEventListener("click", function (e) {
      var minus = e.target.closest("[data-cart-minus]");
      var plus = e.target.closest("[data-cart-plus]");
      var remove = e.target.closest("[data-cart-remove]");
      var row = e.target.closest("[data-cart-item]");
      if (!row) return;
      var key = row.getAttribute("data-key");
      var input = row.querySelector("[data-cart-qty-input]");
      var n = parseInt(input && input.value, 10) || 1;
      if (minus) changeCartItem(key, Math.max(1, n - 1));
      if (plus) changeCartItem(key, n + 1);
      if (remove) changeCartItem(key, 0);
    });
    root.addEventListener("change", function (e) {
      var input = e.target.closest("[data-cart-qty-input]");
      if (!input) return;
      var row = input.closest("[data-cart-item]");
      if (!row) return;
      var n = parseInt(input.value, 10);
      if (!n || n < 1) n = 1;
      changeCartItem(row.getAttribute("data-key"), n);
    });
  };
  bindCartQty(cart);
  bindCartQty(cartPage);
  document.querySelectorAll("[data-thumb]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var img = document.getElementById("v8-main-image");
      if (img) img.src = btn.getAttribute("data-thumb");
      document.querySelectorAll("[data-thumb]").forEach(function (b) {
        b.classList.remove("is-active");
      });
      btn.classList.add("is-active");
    });
  });

  document.querySelectorAll(".hh2v-media video").forEach(function (video) {
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute("muted", "");
    video.setAttribute("playsinline", "");
    var play = video.play();
    if (play && play.catch) play.catch(function () {});
  });

  document.querySelectorAll("[data-buy-box]").forEach(function (box) {
    var idInput = box.querySelector("[data-variant-input]");
    var atc = box.querySelector("[data-atc]");
    box.querySelectorAll("[data-variant-id]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var group = btn.parentElement;
        if (!group) return;
        group.querySelectorAll("[data-variant-id]").forEach(function (el) {
          el.classList.remove("is-selected");
        });
        btn.classList.add("is-selected");
        var vid = btn.getAttribute("data-variant-id");
        var price = btn.getAttribute("data-price");
        if (idInput && vid) idInput.value = vid;
        if (atc && price) atc.textContent = "Add to cart - " + price;
        if (vid && window.history && window.history.replaceState) {
          try {
            var url = new URL(window.location.href);
            url.searchParams.set("variant", vid);
            window.history.replaceState({}, "", url.toString());
          } catch (e) {}
        }
      });
    });
    var qtyWrap = box.querySelector("[data-qty]");
    var input = box.querySelector("[data-qty-input]");
    var hidden = box.querySelector("[data-qty-hidden]");
    var sync = function () {
      var n = parseInt(input.value, 10);
      if (!n || n < 1) n = 1;
      input.value = n;
      if (hidden) hidden.value = n;
    };
    if (qtyWrap && input) {
      var minus = qtyWrap.querySelector("[data-qty-minus]");
      var plus = qtyWrap.querySelector("[data-qty-plus]");
      if (minus) minus.addEventListener("click", function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        sync();
      });
      if (plus) plus.addEventListener("click", function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
        sync();
      });
      input.addEventListener("change", sync);
    }
  });

  document.querySelectorAll(".hpr2-section").forEach(function (section) {
    var btns = section.querySelectorAll(".hpr2-logo-btn");
    var slides = section.querySelectorAll(".hpr2-slide");
    btns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var index = btn.getAttribute("data-press");
        btns.forEach(function (b) { b.removeAttribute("data-active"); });
        slides.forEach(function (s) { s.removeAttribute("data-active"); });
        btn.setAttribute("data-active", "");
        slides.forEach(function (s) {
          if (s.getAttribute("data-press-slide") === index) s.setAttribute("data-active", "");
        });
      });
    });
  });

  document.querySelectorAll("[data-review-tabs]").forEach(function (root) {
    var tabs = root.querySelectorAll("[data-tab]");
    var cards = root.querySelectorAll("[data-tags]");
    var show = function (key) {
      tabs.forEach(function (t) {
        if (t.getAttribute("data-tab") === key) t.classList.add("is-active");
        else t.classList.remove("is-active");
      });
      cards.forEach(function (card) {
        var tags = " " + (card.getAttribute("data-tags") || "") + " ";
        card.hidden = tags.indexOf(" " + key + " ") === -1;
      });
    };
    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        show(tab.getAttribute("data-tab"));
      });
    });
    show("all");
  });

  document.querySelectorAll("[data-faq-more]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var root = btn.closest("[data-faq]");
      if (!root) return;
      var box = root.querySelector(".pf2-container");
      if (box) box.classList.remove("is-collapsed");
    });
  });

  document.querySelectorAll(".hex2-video-wrap[data-video-url]").forEach(function (wrap) {
    var play = function () {
      if (wrap.classList.contains("is-playing")) return;
      var url = wrap.getAttribute("data-video-url");
      if (!url) return;
      var video = document.createElement("video");
      video.src = url;
      video.setAttribute("playsinline", "");
      video.setAttribute("controls", "");
      video.autoplay = true;
      wrap.appendChild(video);
      wrap.classList.add("is-playing");
    };
    wrap.addEventListener("click", play);
    wrap.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        play();
      }
    });
  });

  document.querySelectorAll("[data-customer-reviews]").forEach(function (root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll(".jcr2-card"));
    var search = root.querySelector("[data-rev-search]");
    var sort = root.querySelector("[data-rev-sort]");
    var sortLabel = root.querySelector("[data-sort-label]");
    var concern = root.querySelector("[data-rev-concern]");
    var type = root.querySelector("[data-rev-type]");
    var wash = root.querySelector("[data-rev-wash]");
    var more = root.querySelector("[data-rev-more]");
    var expanded = false;
    cards.forEach(function (card) {
      var p = card.querySelector("[data-rev-text]");
      if (!p) return;
      var full = p.textContent;
      if (full.length > 240) {
        p.setAttribute("data-full", full);
        p.textContent = full.slice(0, 220).replace(/\s+\S*$/, "") + "... ";
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "jcr2-read";
        btn.textContent = "Read more";
        btn.addEventListener("click", function () {
          p.textContent = p.getAttribute("data-full");
          btn.remove();
        });
        p.appendChild(btn);
      }
    });
    var apply = function () {
      var q = ((search && search.value) || "").toLowerCase();
      var c = (concern && concern.value) || "all";
      var t = (type && type.value) || "all";
      var w = (wash && wash.value) || "all";
      var visible = cards.filter(function (card) {
        var hay = card.innerText.toLowerCase();
        if (q && hay.indexOf(q) === -1) return false;
        if (c !== "all" && (card.getAttribute("data-concern") || "").indexOf(c) === -1) return false;
        if (t !== "all" && (card.getAttribute("data-type") || "").indexOf(t) === -1) return false;
        if (w !== "all" && (card.getAttribute("data-wash") || "") !== w) return false;
        return true;
      });
      var dir = sort && sort.value === "oldest" ? 1 : -1;
      visible.sort(function (a, b) {
        return dir * ((a.getAttribute("data-date") || "").localeCompare(b.getAttribute("data-date") || ""));
      });
      cards.forEach(function (card) {
        card.classList.add("is-hidden");
        card.classList.remove("is-visible");
      });
      visible.forEach(function (card, i) {
        if (!expanded && i >= 5) return;
        card.classList.remove("is-hidden");
        card.classList.add("is-visible");
        root.querySelector("[data-rev-list]").appendChild(card);
      });
      if (more) more.hidden = expanded || visible.length <= 5;
    };
    if (more) more.addEventListener("click", function () {
      expanded = true;
      apply();
    });
    root.querySelectorAll("[data-pill]").forEach(function (pill) {
      pill.addEventListener("click", function () {
        if (search) search.value = pill.getAttribute("data-pill") || "";
        apply();
      });
    });
    [search, sort, concern, type, wash].forEach(function (el) {
      if (!el) return;
      el.addEventListener("input", apply);
      el.addEventListener("change", apply);
    });
    if (sort) sort.addEventListener("change", function () {
      if (sortLabel) sortLabel.textContent = sort.options[sort.selectedIndex].text;
    });
    apply();
  });

  document.querySelectorAll("[data-hair-slider]").forEach(function (root) {
    var track = root.querySelector("[data-hair-track]");
    var dots = root.querySelectorAll("[data-hair-dot]");
    if (!track) return;
    var tiles = track.querySelectorAll(".hhq2-tile");
    var setDot = function () {
      if (!tiles.length) return;
      var mid = track.scrollLeft + track.clientWidth / 2;
      var idx = 0;
      var best = Infinity;
      tiles.forEach(function (tile, i) {
        var c = tile.offsetLeft + tile.offsetWidth / 2;
        var d = Math.abs(c - mid);
        if (d < best) {
          best = d;
          idx = i;
        }
      });
      dots.forEach(function (dot, i) {
        if (i === idx) dot.classList.add("is-active");
        else dot.classList.remove("is-active");
      });
    };
    track.addEventListener("scroll", setDot, { passive: true });
    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function () {
        var tile = tiles[i];
        if (!tile) return;
        track.scrollTo({ left: tile.offsetLeft - (track.clientWidth - tile.offsetWidth) / 2, behavior: "smooth" });
      });
    });
  });
})();
